import React, { useState } from "react";
import classes from "./InputForm.module.css";

const postcodes = [
  "RG1",
  "RG2",
  "RG4",
  "RG5",
  "RG6",
  "RG10",
  "RG12",
  "RG30",
  "RG31",
  "RG40",
  "RG41",
  "RG42",
  "RG45",
  "SL4",
  "SL5",
  "SL6",
  "GU14",
  "GU15",
  "GU16",
  "GU18",
  "GU19",
  "GU25",
  "GU47",
];

const InputForm = ({ updateState, postCode }) => {
  const [input, setInput] = useState(postCode);

  const validInput = (foo) => {
    return postcodes.some((postcode) => foo.includes(postcode));
  };

  let buttonClasses = [classes.inputFormButton];

  if (validInput(input)) {
    buttonClasses.push(classes.buttonWhenInput);
  }

  return (
    <div className={classes.inputFormContainer}>
      <input
        className={classes.inputForm}
        type="text"
        placeholder="Enter your postcode"
        value={input}
        onChange={(e) => setInput(e.target.value.toUpperCase().trim())}
      />

      <button
        className={buttonClasses.join(" ")}
        onClick={() => updateState(input)}
        disabled={validInput(input) ? false : true}
      >
        Confirm
      </button>
      {input.length > 3 && !validInput(input) ? (
        <span className={classes.sorry}>
          We can only serve addresses within a 30 minute drive of Bracknell.
        </span>
      ) : null}
    </div>
  );
};

export default InputForm;
